import React from 'react'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import styles from './style.module.scss'
import LanguageSelector from '../../components/LayoutComponents/TopBar/LanguageSelector'

@withRouter
class LoginLayout extends React.PureComponent {
  state = {
    backgroundNumber: 1,
    backgroundEnabled: false,
  }

  changeBackground = () => {
    const { backgroundNumber } = this.state
    this.setState({
      backgroundEnabled: true,
      backgroundNumber: backgroundNumber === 5 ? 1 : backgroundNumber + 1,
    })
  }

  toggleBackground = () => {
    const { backgroundEnabled } = this.state
    this.setState({
      backgroundEnabled: !backgroundEnabled,
    })
  }

  render() {
    const { children } = this.props
    const { backgroundNumber, backgroundEnabled } = this.state

    return (
      <Layout>
        <Layout.Content>
          <div
            className={backgroundEnabled ? `${styles.layout} ${styles.light}` : `${styles.layout}`}
            style={{
              backgroundImage: backgroundEnabled
                ? `url('resources/images/photos/${backgroundNumber}.jpeg')`
                : `none`,
            }}
          >
            <div className={styles.header}>
              <div className={styles.logo}>
                <a href="http://www.imova.cl/" target="_blank" rel="noopener noreferrer">
                  {!backgroundEnabled && (
                    <img src="resources/images/Logo-Imova_negro.png" alt="Reportería Imova" />
                  )}
                  {backgroundEnabled && (
                    <img src="resources/images/Logo-Imova_Blanco.png" alt="Reportería Imova" />
                  )}
                </a>
              </div>

              <nav className={styles.navigation}>
                <ul className={styles.navigationItems}>
                  <li>
                    <a href="http://www.imova.cl">
                      &larr; <FormattedMessage id="login.back" />
                    </a>
                  </li>
                  <li>
                    <a href="mailto:contacto@imova.cl">
                      <FormattedMessage id="login.support" />
                    </a>
                  </li>
                  <li>
                    <div className="mr-4">
                      <LanguageSelector />
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
            <div className={styles.content}>{children}</div>
            <div className={`${styles.footer} text-center`}>
              <p>&copy; {Math.floor(Date.now() / 365 / 24 / 60 / 60 / 1000) + 1970} Imova</p>
            </div>
          </div>
        </Layout.Content>
      </Layout>
    )
  }
}

export default LoginLayout
